import React from "react";
import { REPORT_CHARTS } from "./mockData";

const LineChart = ({ labels, values, color = "#0087e2" }) => {
    const max = Math.max(...values, 1);
    return (
        <div className="clk-mk-line-chart">
            <div className="clk-mk-line-bars">
                {values.map((v, i) => (
                    <div key={labels[i]} className="clk-mk-line-col">
                        <span
                            className="clk-mk-line-bar"
                            style={{ height: `${(v / max) * 100}%`, background: color }}
                            title={`${labels[i]}: ${v}`}
                        />
                        <span className="clk-mk-line-lbl">{labels[i]}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

const VBarChart = ({ bars }) => {
    const max = Math.max(...bars.map((b) => b.value), 1);
    return (
        <div className="clk-mk-vbars clk-mk-vbars--report">
            {bars.map((bar) => (
                <div key={bar.label} className="clk-mk-vbar-col">
                    <span
                        className="clk-mk-vbar-fill"
                        style={{ height: `${(bar.value / max) * 100}%`, background: bar.color }}
                    />
                    <span className="clk-mk-vbar-val">{bar.value}</span>
                    <span className="clk-mk-vbar-lbl">{bar.label}</span>
                </div>
            ))}
        </div>
    );
};

const HBarChart = ({ rows }) => {
    const max = Math.max(...rows.map((r) => r.value), 1);
    return (
        <div className="clk-mk-dept-chart clk-mk-dept-chart--report">
            {rows.map((row) => (
                <div key={row.label} className="clk-mk-dept-chart-row">
                    <span className="clk-mk-dept-chart-lbl">{row.label}</span>
                    <span className="clk-mk-dept-chart-track">
                        <i style={{ width: `${(row.value / max) * 100}%`, background: row.color }} />
                    </span>
                    <span className="clk-mk-dept-chart-val">{row.value}</span>
                </div>
            ))}
        </div>
    );
};

const DonutChart = ({ segments }) => {
    const total = segments.reduce((s, x) => s + x.value, 0);
    let acc = 0;
    const gradient = segments
        .map((seg) => {
            const start = (acc / total) * 100;
            acc += seg.value;
            const end = (acc / total) * 100;
            return `${seg.color} ${start}% ${end}%`;
        })
        .join(", ");

    return (
        <div className="clk-mk-donut-wrap">
            <div className="clk-mk-donut" style={{ background: `conic-gradient(${gradient})` }}>
                <div className="clk-mk-donut-hole">{total}</div>
            </div>
            <ul className="clk-mk-donut-legend">
                {segments.map((seg) => (
                    <li key={seg.label}>
                        <i style={{ background: seg.color }} />
                        {seg.label} · {seg.value}%
                    </li>
                ))}
            </ul>
        </div>
    );
};

const MockReports = () => {
    const { volume, response, priority, team, status, departments, resolution } = REPORT_CHARTS;

    return (
        <div className="clk-mk-reports">
            <div className="clk-mk-page-head">
                <h4>Reports · Overview</h4>
                <span className="clk-mk-page-meta">Jun 5 to Jun 12, 2026</span>
            </div>
            <div className="clk-mk-reports-grid">
                <div className="clk-mk-report-card">
                    <h6>{volume.title}</h6>
                    <p>{volume.subtitle}</p>
                    <LineChart labels={volume.labels} values={volume.values} color="#0087e2" />
                </div>
                <div className="clk-mk-report-card">
                    <h6>{response.title}</h6>
                    <p>{response.subtitle}</p>
                    <LineChart labels={response.labels} values={response.values} color="#059669" />
                </div>
                <div className="clk-mk-report-card">
                    <h6>{priority.title}</h6>
                    <p>Current open queue</p>
                    <DonutChart segments={priority.segments} />
                </div>
                <div className="clk-mk-report-card">
                    <h6>{status.title}</h6>
                    <p>{status.subtitle}</p>
                    <VBarChart bars={status.bars} />
                </div>
                <div className="clk-mk-report-card">
                    <h6>{departments.title}</h6>
                    <p>{departments.subtitle}</p>
                    <HBarChart rows={departments.rows} />
                </div>
                <div className="clk-mk-report-card">
                    <h6>{resolution.title}</h6>
                    <p>{resolution.subtitle}</p>
                    <DonutChart segments={resolution.segments} />
                </div>
                <div className="clk-mk-report-card clk-mk-report-card--wide">
                    <h6>{team.title}</h6>
                    <p>This period</p>
                    <table className="clk-mk-mini-table">
                        <thead>
                            <tr>
                                <th>Agent</th>
                                <th>Replies</th>
                                <th>Solved</th>
                            </tr>
                        </thead>
                        <tbody>
                            {team.rows.map((r) => (
                                <tr key={r.name}>
                                    <td>{r.name}</td>
                                    <td>{r.replies}</td>
                                    <td>{r.solved}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default MockReports;
